
import { Message } from 'iview';
import { isCancel } from 'axios';
import { KEY } from '@/config';
import { ChangeEnvironment, ClientIsGrayHttpDate } from './clientGray';
// axios的请求拦截器

// 请求拦截
const request = (config) => {
  const arg = config;
  const params = { // 每个请求的查询参数带上key and time
    timestamp: new Date().getTime(),
    key: KEY,
  };
  arg.params = Object.assign({}, arg.params, params); // 合并query string
  // arg.url = `${arg.url}&timestamp=${new Date().getTime()}&key=${BASEKEY}`;
  arg.data = Object.assign(arg.data, ClientIsGrayHttpDate);
  if (!arg.validation) { // 是否有需要登录验证的接口
    return arg;
  }
  // const loginTime = sessionStorage.getItem('loginTime');
  // if (loginTime && ((loginTime - new Date().getTIme) < (5 * 60 * 60 * 1000))) {
  //   // 设置五小时后登录过期，超过五小时提示用户登录
  //   sessionStorage.clear();
  //   // ..路由跳转
  // } else if (!loginTime) {
  //   // 没有登录时间则为没登录或者关闭了页面
  //   sessionStorage.clear();
  //   // ..路由跳转
  //   return arg; // 暂时这样写
  // }
  return arg;
};

// 如果请求失败或者报错
const requestErr = error => Promise.reject(error.response);

// 响应拦截
const response = (res) => {
  // 过滤请求为 5xx, 4xx的状态码，提示用户
  if (/^4|5\d{2}$/.test(res.status)) {
    // ... xxx错误
    let message = '';
    switch (res.status) {
      case '500': {
        message = '500 错误 链接不存在';
        break;
      }
      case '404': {
        message = '404 错误 请求的网页不存在';
        break;
      }
      case '503': {
        message = '503 错误 服务不可用';
        break;
      }
      default:
        message = '网络错误，请检查网络后重试！';
    }
    Message.error(message);
    return Promise.reject(res.data);
  }
  if (isCancel(res.data)) {
    // 如果是取消上请求的状态
    return Promise.reject(res.data);
  }
  if (!res.data || (typeof res.data.status === 'undefined')) {
    // 服务器返回空信息
    return Promise.reject(res.data);
  }
  if (res.data.status === 1001) {
    // 切换灰度环境
    ChangeEnvironment();
    return Promise.reject(res.data);
  }
  // 对于后台服务器返回的状态码不为1的情况下的处理
  if (res.data.status !== 1) {
    return Promise.reject(res.data);
  }
  return Promise.resolve(res.data);
};

// 响应错误处理
const responseErr = (error) => {
  // 状态码为1xx,3xx,5xx以及请求超时的时候提示
  let message = '';
  if (isCancel(error)) { // 是否是手动取消请求或者跳转路由时取消上一个页面的请求
    return Promise.reject(error);
  }
  if (error.message.indexOf('timeout') !== -1) {
    message = '请求超时，请刷新页面或者重新登录！';
  } else {
    message = '网络错误，请检查网络后重试！';
  }
  Message.error(message);
  return Promise.reject(error);
};

export {
  request,
  requestErr,
  response,
  responseErr,
};
